export default __webpack_public_path__ + "static/media/sports-img-banner.d8daa786.png";